<template>
  <div
    class="template-landing-button-slot"
    :class="{ 'template-landing-button-slot--full-width': props.fullWidth }"
  >
    <BaseButton
      v-if="!props.button"
      variant="primary"
      outlined
      size="md"
      :with-full="props.fullWidth"
      class="template-landing-button-slot__add"
      @click="handleAddClick"
    >
      Добавить кнопку
      <template #append-icon>
        <BaseIcon
          name="vuesax:info-circle-linear"
          size="20px"
          color="var(--color-foreground-primary)"
        />
      </template>
    </BaseButton>
    <BaseButton
      v-else
      variant="primary"
      size="md"
      rounded
      :color="props.button.color"
      :text-color="filledTextColor"
      :with-full="props.fullWidth"
      class="template-landing-button-slot__filled"
      @click="handleEditClick"
    >
      {{ props.button.label }}
      <template #append-icon>
        <BaseButtonIcon
          icon-name="vuesax:close-linear"
          icon-size="14px"
          form="circle"
          size="xxs"
          variant="light"
          icon-color="var(--color-foreground-regular)"
          aria-label="Удалить кнопку"
          @click.stop="handleClearClick"
        />
      </template>
    </BaseButton>
  </div>
</template>

<script setup lang="ts">
import type { ILandingTemplateButton } from '~/entities/projects/model/landingTemplateButtons'
import { isHexColorDark, parseHexColor } from '~/shared/lib'
import { BaseButton, BaseButtonIcon, BaseIcon } from '~/shared/ui'

interface Props {
  button?: ILandingTemplateButton | null
  fullWidth?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  fullWidth: false,
})

const emit = defineEmits<{
  (e: 'add'): void
  (e: 'edit'): void
  (e: 'clear'): void
}>()

const filledTextColor = computed(() => {
  const color = props.button?.color?.trim()
  if (color && parseHexColor(color) && !isHexColorDark(color)) {
    return 'var(--color-foreground-regular)'
  }
  return 'var(--color-foreground-light)'
})

function handleAddClick() {
  emit('add')
}

function handleEditClick() {
  emit('edit')
}

function handleClearClick() {
  emit('clear')
}
</script>

<style lang="scss" scoped>
.template-landing-button-slot {
  width: fit-content;
  max-width: 100%;
  align-self: flex-start;

  &__add {
    border-radius: rem(14px);

    > p {
      @include typo-subtitle;

      font-weight: 700;
    }

    &.base-button--outlined {
      border-width: 1px;
    }
  }

  &__filled {
    border-radius: rem(14px);

    > p {
      text-align: left;
    }
  }

  &--full-width {
    width: 100%;
    align-self: stretch;

    .template-landing-button-slot__add,
    .template-landing-button-slot__filled {
      width: 100%;
    }
  }

  @include bp-media('xs', 'sm') {
    width: 100%;
    align-self: stretch;

    .template-landing-button-slot__add,
    .template-landing-button-slot__filled {
      width: 100%;
    }
  }
}
</style>
